import { render, staticRenderFns } from "./AddUserIdentification.vue?vue&type=template&id=e87f7d98&"
import script from "./AddUserIdentification.vue?vue&type=script&lang=js&"
export * from "./AddUserIdentification.vue?vue&type=script&lang=js&"
import style0 from "./AddUserIdentification.vue?vue&type=style&index=0&id=e87f7d98&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports